<div class="backdrop" (click)="onBackdropClick($event)">
    <div class="qr-code-popup" (click)="onPopupClick($event)">
      <img [src]="qrCodeImage" alt="QR Code">
    </div>
  </div>
